/**
 * Created by yangruyue on 2017/3/10.
 */

import Clipboard from 'clipboard';
import KsTooltipAdv from '../KsTooltipAdv/index.vue'

export default {
    components: {
        KsTooltipAdv
    },
    name: 'KsIdLabel',
    data() {
        return {
            clipboard: null,
        }
    },
    props: ['msg'],
    methods: {
        copy(e) {
            this.clipboard.onClick(e)
        }
    },
    mounted() {
        this.$nextTick(() => {
            var me = this;
            this.clipboard = new Clipboard('.ks-tooltip-adv-content-copy-btn');
            this.clipboard.on('success', function(e) {
                e.clearSelection();
                me.$emit('on-copy',true)
            });

            this.clipboard.on('error', function(e) {
                me.$emit('on-copy',false)

            });

        });
    }

}
